import { useState } from 'react';
import {
  getSystemFieldsConfiguration,
  updateSystemFieldsConfiguration,
} from 'requests/settings';
import { IOptionalFieldDetails, IOptionalField } from 'models/settings';
import { ActionTypes } from 'state/actions/alert';
import { useTranslations } from 'hooks/useTranslations';
import { useAlert } from 'models/alertContext';
import { EAlertVariants } from 'components/atoms/Alert';
import { LEModuleTypes } from 'constants/LegalEntityTypes';
import { EFieldsOptional } from './helpers';

export const useSystemFieldsConfiguration = () => {
  const { setAlert } = useAlert();
  const { t } = useTranslations();
  const [fieldsOptional, setFieldsOptional] = useState<IOptionalFieldDetails[]>([]);
  const [hiddenFieldsName, setHiddenFieldsName] = useState<EFieldsOptional[]>([]);
  const [requiredFieldsName, setRequiredFieldsName] = useState<EFieldsOptional[]>([]);

  const getFieldsOptional = async (module?: LEModuleTypes[]) => {
    const result = await getSystemFieldsConfiguration(
      module ?? [LEModuleTypes.individual, LEModuleTypes.organisation],
    );
    setHiddenFieldsName([]);
    setRequiredFieldsName([]);

    if (result) {
      setFieldsOptional(result);
      result.map((field) => {
        if (!field.visible) {
          setHiddenFieldsName((previous) => [...previous, field.name as EFieldsOptional]);
        }
        if (field.required) {
          setRequiredFieldsName((previous) => [...previous, field.name as EFieldsOptional]);
        }
      });
    } else {
      setFieldsOptional([]);
    }
  };

  const updateSystemFieldsConfigurationData = async (data: IOptionalField[]) => {
    try {
      const response = await updateSystemFieldsConfiguration(data);
      if (response) {
        await setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('updateSystemFieldsConfiguration.success.text'),
        });
      }
      return true;
    } catch (e: any) {
      await setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const prepareFormByFieldsOptional = (fields: IOptionalFieldDetails[], setValues?: any) => {
    fields.map((field) => {
      if (!field.visible) {
        if (setValues) {
          setValues(field.name, null);
        }
      }
    });
  };

  return {
    fieldsOptional,
    getFieldsOptional,
    updateSystemFieldsConfigurationData,
    prepareFormByFieldsOptional,
    hiddenFieldsName,
    requiredFieldsName,
  };
};
